import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, inject } from '@angular/core';

import { ConfigurationService } from '@bytel/checkout';

import { AppService } from '@services/app.services';
import { MainCartService } from '@services/main-cart.service';

import { ModalComponent } from '@shared/modal/modal.component';
import { ModalTypes } from '@shared/modal/modal.interface';
import { PaymentStep } from '../stepper/steps/payment.step';

@Component({
    selector: 'checkout-swappy-modal',
    imports: [ModalComponent],
    templateUrl: './swappy-modal.component.html',
    styleUrl: './swappy-modal.component.scss',
    standalone: true,
})
export class SwappyModalComponent extends ModalComponent implements OnInit {
    @Input() hasSwappyError: boolean;
    @Input() title: string;

    type: ModalTypes = 'error';
    tagEventImp: Record<string, string> = {
        nomClic: 'Affichage_modale_erreur_swappy',
        categorieClic: 'Modale_erreur',
    };
    tagEventCTA: Record<string, string> = {
        nomClic: 'Redirect_swappy',
        categorieClic: 'Modale_erreur_swappy',
    };
    tagEventClose: Record<string, string> = {
        nomClic: 'Fermeture',
        categorieClic: 'Modale_erreur_swappy',
    };

    private cartService: MainCartService = inject(MainCartService);
    private appService: AppService = inject(AppService);
    private configService: ConfigurationService = inject(ConfigurationService);
    @Inject(DOCUMENT) private document: Document = inject(DOCUMENT);
    private paymentStep: PaymentStep = inject(PaymentStep);

    public ngOnInit(): void {
        this.modalRef.afterClosed.subscribe(() => {
            this._resetCartAndRedirect('https://www.bouyguestelecom.fr');
        })
    }

    swappyAction(): void {
        if (this.hasSwappyError) {
            this._resetCartAndRedirect(this.configService.getData().global.wall.stores);
        } else {
            this.document.location.href = this.paymentStep.routerLink;
        }
    }

    private _resetCartAndRedirect(redirectLink: string): void {
        this.cartService.resetAll();
        this.cartService.addQuote();
        this.cartService.save();
        this.cartService.refresh();
        this.appService.navigateTo(redirectLink);
    }
}
